import styled from "styled-components";

const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 9;
  background: linear-gradient(180deg, white 0%, white 80%, transparent 100%);
`;

export default StickyHeader;
